import {
  createContext,
  createElement,
  type ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react';

export interface ViewBreadcrumbSelection {
  title: string;
  homePath: string;
  isHome: boolean;
}

const ViewNavigationState = createContext<{
  breadcrumb: ViewBreadcrumbSelection | null;
  setBreadcrumb: (value: ViewBreadcrumbSelection | null) => void;
} | null>(null);

/** Local reader interaction, scoped to one rendered page. Never writes app data. */
export function ViewNavigationStateProvider({
  children,
}: {
  children?: ReactNode;
}) {
  const [breadcrumb, setBreadcrumb] = useState<ViewBreadcrumbSelection | null>(
    null
  );
  const value = useMemo(() => ({ breadcrumb, setBreadcrumb }), [breadcrumb]);
  return createElement(ViewNavigationState.Provider, { value }, children);
}

export function useViewNavigationState() {
  return useContext(ViewNavigationState);
}
